export const themesConstants = {
    THEMES_REQUEST: 'THEMES_REQUEST',
    THEMES_ALL_SUCCESS: 'THEMES_ALL_SUCCESS',
    THEMES_ERROR: 'THEMES_ERROR',
};
